import { useEffect, useState } from 'react';
import QuestionItemCard from './QuestionItemCard';
import { useFormContext } from 'react-hook-form';
import Ruby from 'components/modules/Student/Ruby';
import { SliderRangeCandidate } from './SliderRangeCandidate';

export const SliderRange = props => {
    const {
        sliderRangeMax,
        sliderRangeMin,
        sliderInitialUserValue,
        showSliderValueDetails,
        sliderRangeMinDetail,
        sliderRangeMaxDetail,
        sliderInitialUserValueDetail,
        content,
        detail,
        file,
        isRequired,
        name,
    } = props;
    const { formState: { errors }, register, unregister, watch, setValue } = useFormContext();
    
    const [validate, setValidate] = useState(undefined);

    useEffect(() => {// 初期値セット
        if (sliderInitialUserValue) setValue(name, sliderInitialUserValue);
    }, [sliderInitialUserValue, name, setValue]);

    let errorMessage = '';
    if (errors[name]?.message !== undefined) {
        switch (errors[name].type) {
            case 'required':
                errorMessage = <Ruby>{'{回答|かいとう}が{必要|ひつよう}です。'}</Ruby>;
                break;
            default:
                errorMessage = <div>{errors[name].message}</div>;
                break;
        }
    }

    return (
        <QuestionItemCard
            title={content}
            detail={detail}
            file={file}
            error={errorMessage}
            isRequired={isRequired}
            type={<Ruby>{'スライダー{選択|せんたく }'}</Ruby>}
            watch={watch}
        >
            <SliderRangeCandidate
                name={name}
                sliderRangeMin={sliderRangeMin}
                sliderRangeMax={sliderRangeMax}
                sliderInitialUserValue={sliderInitialUserValue}
                register={register(name, validate)}
                showSliderValueDetails={showSliderValueDetails}
                sliderRangeMinDetail={sliderRangeMinDetail}
                sliderRangeMaxDetail={sliderRangeMaxDetail}
                sliderInitialUserValueDetail={sliderInitialUserValueDetail}
            />

            {/* 詳細（detail）の改行文字に応じて背景色を変更する処理 */}
            <div className='flex invisible'>
                <div className='w-[50px] break-all'>{sliderRangeMinDetail}</div>
                <div className='w-[50px] break-all'>{sliderInitialUserValueDetail}</div>
                <div className='w-[50px] break-all'>{sliderRangeMaxDetail}</div>
            </div>
        </QuestionItemCard>
    )
}